import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  loadingEvent = new Subject<boolean>();

  show() {
    this.loadingEvent.next(true);
  }

  hide() {
    this.loadingEvent.next(false);
  }
}
